import React, { useState } from 'react';
import Heading from '@legacy-vfuk/core-heading';
import { SecondQuestionProps } from '../../Types/SecondQuestion.types';
import { ContentFullTypesForAboutBusinessSection } from '../../Types/SectionAssessmentAboutBusiness.types';
import { HeadingWrapper } from '../../styles/SectionAssessmentAboutBusiness.styles';
import fireButtonAndLinkClicksEvent from '../../../../../../helpers/fireButtonAndLinkClicksEvent';

const getImage = (
  index: number,
  content: ContentFullTypesForAboutBusinessSection
) => {
  const secondQuestionImage = content.secondQuestionImages;
  switch (index) {
    case 0:
      return secondQuestionImage.accommodationFood.file.url;
    case 1:
      return secondQuestionImage.artsEntertainment.file.url;
    case 2:
      return secondQuestionImage.construction.file.url;
    case 3:
      return secondQuestionImage.education.file.url;
    case 4:
      return secondQuestionImage.financialInsurance.file.url;
    case 5:
      return secondQuestionImage.goodsManufacturing.file.url;
    case 6:
      return secondQuestionImage.humanHealthSocialWork.file.url;
    case 7:
      return secondQuestionImage.informationCommunication.file.url;
    case 8:
      return secondQuestionImage.professionalService.file.url;
    case 9:
      return secondQuestionImage.travelTransportation.file.url;
    case 10:
      return secondQuestionImage.wholesaleRetailTrade.file.url;
    case 11:
      return secondQuestionImage.other.file.url;
    default:
      return secondQuestionImage.defaultIcon.file.url;
  }
};

const SecondQuestion = ({
  content,
  index,
  item,
  getQuestionImage,
  firstsetquestions,
  nextEvent,
}: SecondQuestionProps) => {
  const [click, setClick] = useState<number>();
  return (
    <div id="carouselItem" className="question2">
      <div>
        <img className="sureyQueImage" src={getQuestionImage(index + 1)} />
      </div>
      <div className="questionStyle">
        {`${content.questionNumberText1} ${index + 2} ${
          content.questionNumberText2
        } ${firstsetquestions.length + 3}`}
      </div>
      <HeadingWrapper>
        <Heading text={item.questionText} weight={2} size={2} noMargin={true} />
      </HeadingWrapper>
      <div className="asses-helper-text">{content.headingText[index]}</div>
      <div className="mostly-customized-scrollbar">
        <div className="qckLinksParent">
          <div>
            {item.responseOption.map((option: any, index: number) => (
              <div
                id={click === index ? 'test-active' : 'test'}
                key={index}
                className={`typeOf-business-image-div${
                  click === index ? ' active' : ''
                }`}
                onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
                  fireButtonAndLinkClicksEvent({ event_action: "button click", event_label: e.currentTarget.lastChild?.textContent || "" });
                  setClick(index);
                  nextEvent(
                    item.id,
                    e.currentTarget.lastChild?.textContent
                      ? e.currentTarget.lastChild.textContent
                      : ''
                  );
                  e.currentTarget.blur();
                }}
              >
                <div>
                  <img
                    src={content.secondQuestionImages.tickIcon.file.url}
                    className={
                      click === index ? ' image-clicked' : 'image-not-clicked'
                    }
                  />
                </div>
                <img
                  id={option}
                  className={`typeOf-business-image${
                    click === index ? ' active' : ''
                  }`}
                  src={getImage(index, content)}
                  alt={option}
                />
                <div className="image-label">{option}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecondQuestion;
